export default __webpack_public_path__ + "static/media/fig7.54c90ac0.jpg";